import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/roth-ira-calculator',
  component: () => import('../../routes/RothIra.svelte'),
  card: {
    id: 'roth-ira',
    title: 'Roth IRA Calculator',
    description: 'Calculate tax-free growth and compare a Roth IRA against a traditional IRA to see how much you could save on taxes.',
    icon: 'account_balance',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/roth-ira-calculator',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Roth IRA Calculator – Tax-Free Growth Projections',
    description: 'Project your Roth IRA growth tax-free over time. Compare against a traditional IRA to see how much you save by paying taxes now rather than at retirement.',
  },
};

export default meta;